/* assets/product-form.js — versión saneada para variantes sin tracking
   - Habilita TODOS los inputs name="id" (no solo el primero)
   - Asegura que el ID de variante activo se envíe correctamente (select/hidden)
   - Mantiene compatibilidad con fetchConfig, PUB_SUB_EVENTS y cart drawer/notification del tema
*/

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;

        // Habilita TODOS los inputs name="id" (en muchos temas hay más de uno)
        this.form.querySelectorAll('[name="id"]').forEach((el) => (el.disabled = false));

        // Botón submit
        this.submitButton = this.querySelector('[type="submit"]');

        // Cart UI (drawer / notification)
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        if (document.querySelector('cart-drawer') && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';

        // Vincula eventos
        this.onSubmitHandler = this.onSubmitHandler.bind(this);
        this.form.addEventListener('submit', this.onSubmitHandler);
      }

      // Obtiene el variant_id seleccionado desde select[name="id"] o hidden
      getActiveVariantId() {
        // 1) Si hay <select name="id"> usa su valor
        const select = this.form.querySelector('select[name="id"]');
        if (select && select.value) return select.value;

        // 2) Si no hay select, usa el primer hidden name="id"
        const hidden = this.form.querySelector('input[type="hidden"][name="id"]');
        if (hidden && hidden.value) return hidden.value;

        // 3) Si hay varios "id", prioriza el que NO esté disabled y tenga valor
        const all = Array.from(this.form.querySelectorAll('[name="id"]'));
        const candidate = all.find((el) => !el.disabled && el.value);
        return candidate ? candidate.value : null;
      }

      // Sincroniza TODOS los name="id" con el valor activo (evita mandar IDs vacíos)
      syncVariantIdInputs(variantId) {
        this.form.querySelectorAll('[name="id"]').forEach((el) => {
          el.disabled = false;
          if (el.tagName === 'SELECT') {
            // si es select, lo dejamos como está (usuario lo controla)
          } else {
            el.value = variantId;
          }
        });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage && this.errorMessage) this.errorMessage.textContent = errorMessage;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (!this.submitButton) return;
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        // Obtén y sincroniza el variant_id activo ANTES de crear el FormData
        const activeId = this.getActiveVariantId();
        if (!activeId) {
          this.handleErrorMessage('Selecciona una variante antes de agregar al carrito.');
          return;
        }
        this.syncVariantIdInputs(activeId);

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          try {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
          } catch (_) {}
          formData.append('sections_url', window.location.pathname);
          if (document.activeElement) this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((r) => r.json())
          .then((response) => {
            if (response && response.status) {
              // Error 422 u otros
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description || 'No se pudo agregar el producto.');

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (soldOutMessage) {
                this.submitButton.setAttribute('aria-disabled', true);
                const span = this.submitButton.querySelector('span');
                if (span) span.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
              }
              this.error = true;
              return;
            }

            // Sin cart UI → redirigir a /cart
            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }
            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error('[product-form] Network error', e);
            this.handleErrorMessage('Tuvimos un problema de conexión. Intenta de nuevo.');
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            const spinner2 = this.querySelector('.loading__spinner');
            if (spinner2) spinner2.classList.add('hidden');
          });
      }
    }
  );
}
